<template>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.factory_number }}
      </span>
    </div>
  </td>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.serial_number }}
      </span>
    </div>
  </td>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.client_code }}
      </span>
    </div>
  </td>
  <td class="align-middle text-center">
    <span class="text-secondary text-xs font-weight-bold">{{ getFormattedDate(item.createdAt) }}</span>
  </td>
</template>

<script>
import moment from "moment";

export default {
  name: "table-tubefl-row",
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods:{
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY")
    },
  }
};
</script>
